/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Deals_MatchingInputs */

const cs_deals_matching = /** @type {(inputs: Deals_MatchingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} shod`)
};

const en_deals_matching = /** @type {(inputs: Deals_MatchingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} matching`)
};

/**
* | output |
* | --- |
* | "{count} matching" |
*
* @param {Deals_MatchingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_matching = /** @type {((inputs: Deals_MatchingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_MatchingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_matching(inputs)
	return cs_deals_matching(inputs)
});